import { createFileRoute } from "@tanstack/react-router";

import { AuthProvider } from "@/providers/auth.provider";
import { PersonaEntry } from "@/features/dashboard/components/persona-entry";

export const Route = createFileRoute("/workspace")({
  component: () => (
    <AuthProvider>
      <PersonaEntry surface="workspace" />
    </AuthProvider>
  ),
});
